<template>
  <CBox>
    <CStack
      :position="['fixed', 'relative']"
      :bottom="[showCancel ? '24px' : '16px', '0']"
      :left="['16px', '0']"
      :right="['16px', '0']"
      align-items="center"
      :spacing="showCancel ? '32px' : '0'"
    >
      <OmtButton
        v-bind="$attrs"
        class="audit-confirm-button"
        :w="['100%', '326px']"
        @click="$emit('continue')"
      >
        {{ continueLabel }}
      </OmtButton>
      <OmtButton
        v-if="showCancel"
        variant="ghost"
        height="19px"
        min-height="19px"
        p="0"
        @click="$emit('cancel')"
      >
        <OmtIcons
          font-size="16px"
          name="trash-can"
          mr="8px"
          size="inherit"
          color="var(--colors-light-support-error)"
        />
        <OmtTypography
          as="button-small"
          color="var(--colors-light-support-error)"
        >
          Cancelar solicitação
        </OmtTypography>
      </OmtButton>
    </CStack>
    <CBox :height="['124px', '0']" />
  </CBox>
</template>

<script>
export default {
  props: {
    continueLabel: {
      type: String,
      default: "Continuar"
    },
    showCancel: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.audit-confirm-button {
  font-size: 20px !important;
  font-weight: 700 !important;
  line-height: 24px !important;
}
</style>
